// Modules
import React from 'react'

// Routes
import Routes from './routes/Main'

// Components
import Page from 'components/layout/page/Page'

// Hooks
// import useLanguage from 'hooks/system/useLanguage'

// Styles
import './Verification.scss'

// Page: Verification
function Verification () {
	// Data
	// const { translate } = useLanguage('pages.verification')

	// Render
	return (
		<Page
			isPublic
			name="verification">
			<Routes />
		</Page>
	)
}

// Export
export default Verification
